import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../../components/ui/tabs/Tabs';

const ReportTableRowSkeleton = () => (
    <div className="grid grid-cols-12 gap-4 px-6 py-3">
        <div className="col-span-3 h-5 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="col-span-9 h-5 bg-gray-200 rounded-md animate-pulse"></div>
    </div>
);

/**
 * Renders the full page skeleton for the Investigation Report screen.
 */
export const InvestigationReportSkeleton = () => {
    // Mimic the tab configuration from the main component
    const tabConfig = [
        { key: 'Investigation', label: 'Investigation' },
        { key: 'Employee Involvement', label: 'Employee Involvement' },
        { key: 'Financial Impact', label: 'Financial Impact' },
        { key: 'Actions Against Parties', label: 'Actions Against Parties' },
        { key: 'Policy Improvements', label: 'Policy Improvements' },
        { key: 'Evidences', label: 'Evidences' },
        { key: 'Chronology', label: 'Chronology' }
    ];

    return (
        <div className="w-full h-full overflow-auto bg-background">
            {/* Skeleton Header */}
            <div className="border-b border-gray-200">
                <div className="max-w-8xl mx-auto px-6 py-4 flex gap-4">
                    <div className="h-8 w-12 bg-gray-200 rounded-md animate-pulse"></div>
                    <div className="h-8 w-1/4 bg-gray-200 rounded-md animate-pulse"></div>
                </div>
            </div>
            <div className="max-w-8xl mx-auto px-6 py-4">
                <div className='flex justify-between'>
                    <div className="h-7 w-1/4 bg-gray-200 rounded-md animate-pulse"></div>
                    <div className='flex gap-4'>
                        <div className="h-7 w-[96px] bg-gray-200 rounded-md animate-pulse"></div>
                        <div className="h-7 w-[96px] bg-gray-200 rounded-md animate-pulse"></div>
                        <div className="h-7 w-[96px] bg-gray-200 rounded-md animate-pulse"></div>
                    </div>
                </div>
            </div>

            {/* Skeleton Tabs */}
            <Tabs defaultValue="Investigation" className="max-w-8xl mx-auto px-6 py-4">
                <TabsList className="w-full bg-transparent justify-start gap-4">
                    {tabConfig.map((tab) => (
                        <div key={tab.key} className="h-5 w-[96px] bg-gray-200 rounded-md animate-pulse"></div>
                    ))}
                </TabsList>

                {/* Skeleton Table Content */}
                <TabsContent value="Investigation">
                     <div className="bg-white">
                        <div className="">
                             <div className="grid grid-cols-12 gap-4 px-6 pt-4 pb-2">
                                <div className="col-span-3 h-8 w-full bg-gray-200 rounded-md animate-pulse"></div>
                                <div className="col-span-9 h-8 w-full bg-gray-200 rounded-md animate-pulse"></div>
                            </div>
                        </div>
                        <div>
                            {[...Array(10)].map((_, i) => <ReportTableRowSkeleton key={i} />)}
                        </div>
                    </div>
                </TabsContent>
            </Tabs>
            <div className="h-24"></div>
        </div>
    );
};

export default InvestigationReportSkeleton;